<template>
  <div class="animated fadeIn">
    <Alerts ref="alert"/>
    <Forms ref="frmAdministrativeLog"
      :title="this.$lang.AdministrativeLog.TitleForm"
      :showHelp="true"
      :showClearButton="true"
      :showSearchButton="true"
      :messageTipFooter="$lang.Common.SelectOrEnterInformationToSearch"
      v-on:Clear="onClear"
      v-on:Search="onSearch">
      <div class="form-group row">
        <div class="col-md-3">
          <label for="txtDateStart">{{$lang.AdministrativeLog.InitialDate}}:</label>
          <div class="input-group">
            <datepicker name="txtDateStart" v-model="form.DateEnd.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fas fa-times'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"/>
          </div>
        </div>
        <div class="col-md-3">
          <label for="txtDateEnd"> {{$lang.AdministrativeLog.FinalDate}}:</label>
          <div class="input-group">
            <datepicker name="txtDateEnd" v-model="form.DateEnd.value"
                        :format="'dd/MM/yyyy'"
                        :language="ptBR"
                        :placeholder="$lang.Common.DatePlaceholder"
                        :clear-button="true"
                        :clear-button-icon="'fas fa-times'"
                        :calendar-button="true"
                        :calendar-button-icon="'fa fa-calendar'"
                        :bootstrap-styling="true"
                        :full-month-name="true"
                        :use-utc="true"/>
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtDescription"> {{$lang.AdministrativeLog.Action}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <label for="txtDescription"> {{$lang.AdministrativeLog.Table}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      />
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtDescription"> {{$lang.AdministrativeLog.Account}}:</label>
          <div class="input-group">
            <v-select style="width: 100%"
                      multiple
                      />
          </div>
        </div>
      </div>
    </Forms>

    <Tables ref="tableGrid"
            :columns="[$lang.AdministrativeLog.DataTable.Table,
                       $lang.AdministrativeLog.DataTable.Type,
                       $lang.AdministrativeLog.DataTable.DateAction,
                       $lang.Common.DataTable.Actions]"
            :showSearch="true"
            :showPrint="true"
            :showDownload="true"
            :showFullscreen="true"
            v-on:Load="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true"     :status=0 :value="obj.tableName" />
        <TableColumn :IsText="true"     :status=1 :value="obj.actionID"/>
        <TableColumn :IsDatetime="true" :status=0 :value="obj.actionDate" />
        <TableColumn :IsActionsDetails="true" />
      </tr>
    </Tables>

  </div>
</template>

<script>
import AdministrativeLog from './administrativelog.js'

export default AdministrativeLog
</script>



// WEBPACK FOOTER //
// src/views/private/access/log/administrativelog.vue